import * as Sentry from '@sentry/browser';

export function initSentry() {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,

    environment: import.meta.env.MODE,
    enabled: import.meta.env.MODE === 'production',

    // Sample rates
    tracesSampleRate: 0.1,
    sampleRate: 1.0,

    // Filter PII before sending
    beforeSend(event) {
      if (event.breadcrumbs) {
        event.breadcrumbs = event.breadcrumbs.map(breadcrumb => {
          if (breadcrumb.data) {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { email, phone, phoneNumber, ...safeData } = breadcrumb.data;
            return { ...breadcrumb, data: safeData };
          }
          return breadcrumb;
        });
      }

      return event;
    },
  });
}
